import dayjs from "dayjs";
import * as types from "../types/cadastro";

const removeDots = (value) => (value ? value.replace(/[^0-9]/g, "") : "");
const formatDate = (date) => (date ? dayjs(date).format("YYYY-MM-DD") : "");
const removeSpace = (space) => (space ? space.trim() : "");

const INITIAL_STATE = {
  loading: false,
  cadastroCartaoLoading: false,
  numeroDaSorte: {},
  dataCompleta: {
    diaNascimento: "",
    mesNascimento: "",
    anoNascimento: "",
  },
  cadastro_site: {
    nome: "",
    cpf: removeDots(""),
    celular: removeDots(""),
    email: removeSpace(""),
    endereco: "",
    numero: "",
    bairro: "",
    cep: "",
    cidade: "",
    uf: "",
    complemento: "",
    dataNascimento: "",
    password: removeSpace(""),
    sexo: "",
    estadoCivil: "",
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CADASTRO_LOADING:
      return { ...state, loading: action.payload };
    case types.CADASTRO_CARTAO_LOADING:
      return { ...state, cadastroCartaoLoading: action.payload };

    case types.CONFIRMA_DIVISAO_IGUAL:
      return { ...state, confirmarDivisao: action.payload };

    case types.DADOS_PESSOAIS_SET:
      return {
        ...state,
        dados_pessoais: { ...state.dados_pessoais, ...action.payload },
      };
    case types.DADOS_PESSOAIS_SITE:
      return {
        ...state,
        cadastro_site: { ...state.cadastro_site, ...action.payload },
      };

    case types.DADOS_DATA_NASCIMENTO:
      return {
        ...state,
        dataCompleta: { ...state.dataCompleta, ...action.payload },
      };

    case types.PESSOA_POLITICAMENTE_EXPOSTA:
      return { ...state, pessoaPoliticamenteExposta: action.payload };

    case types.SET_NUMERO_DA_SORTE:
      return { ...state, numeroDaSorte: action.payload };

    default:
      return state;
  }
};
